import React from 'react';
import { ArrowUpDown, ArrowUp, ArrowDown } from 'lucide-react';
import type { SortConfig } from '../../types/lease';

export type SubLeaseSortField = 
  | 'lease_id' 
  | 'lease_holder' 
  | 'leaseholder_name' 
  | 'lease_start_date' 
  | 'lease_end_date' 
  | 'lease_method' 
  | 'lease_type' 
  | 'lease_furth_term' 
  | 'lease_rent_freq' 
  | 'lease_dealing_no' 
  | 'lease_docs' 
  | 'community' 
  | 'lot_id' 
  | 'lease_dealing' 
  | 'holder' 
  | 'start_date' 
  | 'end_date' 
  | 'rental_amount' 
  | 'status';

interface SubLeaseSortControlsProps {
  sortConfig: SortConfig;
  onSort: (field: SubLeaseSortField) => void;
}

export default function SubLeaseSortControls({ sortConfig, onSort }: SubLeaseSortControlsProps) {
  const getSortIcon = (field: SubLeaseSortField) => {
    if (sortConfig.field !== field) return <ArrowUpDown className="h-4 w-4" />;
    return sortConfig.direction === 'asc' ? 
      <ArrowUp className="h-4 w-4" /> : 
      <ArrowDown className="h-4 w-4" />;
  };

  const buttons = [
    { field: 'community' as SubLeaseSortField, label: 'Community' },
    { field: 'lot_id' as SubLeaseSortField, label: 'Lot ID' },
    { field: 'lease_dealing' as SubLeaseSortField, label: 'Lease Dealing No.' },
    { field: 'holder' as SubLeaseSortField, label: 'Holder' },
    { field: 'start_date' as SubLeaseSortField, label: 'Start Date' },
    { field: 'end_date' as SubLeaseSortField, label: 'End Date' },
    { field: 'rental_amount' as SubLeaseSortField, label: 'Rental Amount' },
    { field: 'status' as SubLeaseSortField, label: 'Status' }
  ];

  return (
    <div className="flex flex-wrap gap-2 mb-4">
      {buttons.map(({ field, label }) => (
        <button
          key={field}
          onClick={() => onSort(field)}
          className={`flex items-center gap-2 px-3 py-2 text-sm font-medium rounded-md border
            ${sortConfig.field === field 
              ? 'border-primary text-primary bg-primary/5' 
              : 'border-gray-300 text-gray-700 hover:bg-gray-50'
            }`}
        >
          {label}
          {getSortIcon(field)}
        </button>
      ))}
    </div>
  );
}
